<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
    <div>
      <v-alert
        :type="alert_type"
        :value="alert"
          :model-value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>
    <loading :active="isLoading" 
      :can-cancel="true" 
      :is-full-page="fullPage" :color="primary_code" />
    <!-- Header-->
    <!-- <header-component :headerTitle="headerText" /> -->
    <header-component class="mx-2"
      :headerTitle="headerText"
      :router-link="getRouterLink()"
      :router-link-text="getRouterLinkText()"
      :component-name="componentsName()"
    />
    <v-snackbar
      v-model="snackbar.visible"
      :color="snackbar.color"
      :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout"
      :top="snackbar.position === 'top'"
    >
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn
        v-if="snackbar.timeout === 0"
        icon
        @click="snackbar.visible = false"
      >
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>

    <v-row justify="center">
      <v-dialog v-model="date_selection_popup" persistent max-width="400px">
        <v-card class="v-card-100">
          <v-row class=" mx-4 pt-4">
            <v-spacer />
            <v-icon @click="date_selection_popup = false">mdi-close</v-icon>
          </v-row>

          <div class="text-center">
            <v-icon color="error" size="40">mdi-information-outline</v-icon>
          </div>
          <div class="text-center mt-6">Selection of atleast one date field is mandatory</div>
          <div class="text-center pb-9" style="text-decoration: underline;color: #0275d8;cursor: pointer;" @click="updateToDateField">Check Date Field</div>
        </v-card>
      </v-dialog>
    </v-row>
    
    <v-row justify="center">
      <v-dialog v-model="scheduleFreqPopup" persistent max-width="700px">
        <v-card class="v-card-100">
              <v-card-title>
                <v-row class="ma-1">
              <span>Schedule Frequency</span>
              <v-spacer></v-spacer>
                <!-- <v-btn icon @click="scheduleFreqPopup = false"> -->
                  <v-icon @click="scheduleFreqPopup = false">mdi-close</v-icon>
                <!-- </v-btn> -->
              </v-row>
            </v-card-title>
          <v-card-text>
            <v-row class="mx-2 mt-3">
              <v-col cols="6">
                <v-autocomplete label="Select Duration" v-model="selected_duration" :items="['Daily','Weekly','Monthly', 'Yearly', 'None']" variant="outlined" hide-details @update:modelValue = "updateDurationDateField"/>
              </v-col>
              <v-col cols="6">
                <v-autocomplete label="Duration Date Field" v-model="selected_duration_date_field" :disabled = "selected_duration === 'None'" :items="selected_date_columns" item-title="value" item-value="key" variant="outlined" hide-details/>
              </v-col>
            </v-row>
            <v-row class="mx-2">
              <v-col>
                <v-autocomplete label="Select Period" v-model="select_period" :items="['Daily','Weekly','Monthly','Custom By Week\'s Day','Custom By Date Of Month']" @update:modelValue="updatePeriodOptions" variant="outlined" hide-details/>
              </v-col>
              <v-col>
                <v-autocomplete v-if="select_period == 'Daily'" label="Repeat Frequency" v-model="repeat_freq" variant="outlined" :items="['1','2','3','4','5','6','7']" hide-details/>
                <v-autocomplete v-if="select_period == 'Weekly'" label="Repeat Day" v-model="days_selected" variant="outlined" :items="['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']" hide-details/>
                <v-autocomplete v-if="select_period == 'Monthly'" label="Repeat Date" v-model="date_selected" variant="outlined" :items="Array.from({length: 31}, (_, i) => i + 1)" hide-details/>
                <v-menu v-if="select_period === 'Custom By Week\'s Day' || select_period === 'Custom By Date Of Month'" ref="menu" v-model="menu" :close-on-content-click="false" offset-y>
                  <template v-slot:activator="{ props }">
                    <v-text-field v-bind="props"  append-inner-icon="mdi-menu-down"
                    :label="select_period === 'Custom By Date Of Month' ? 'Select Date Of Month' : 'Select Days'"
                     variant="outlined" :value="selectedDaysDisplay" readonly hide-details></v-text-field>
                  </template>
                  <v-card>
                    <v-list style="height: 300px; overflow-y: auto !important;">
                      <v-list-item v-for="(day, index) in options_day_months" :key="index">
                        <v-row class="d-flex align-center mx-2 justify-space-between">
                        <v-list-item-content>
                          <v-list-item-title>{{ day }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class="">
                          <v-checkbox v-model="selectedDays" :value="day" hide-details></v-checkbox>
                        </v-list-item-action>
                      </v-row>
                      </v-list-item>
                    </v-list>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn small class="text-none" variant="outlined" color="primary" @click="selectedDays = []">Clear All</v-btn>
                      <v-btn small class="text-none" variant="flat" color="primary" @click="saveSelection"> Save</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
            <v-row class="mx-2">
              <v-col>
                <v-autocomplete label="Sort By" v-model="selected_sort_by" :items="confirm_selected_details" item-title="value" item-value="key" variant="outlined" hide-details/>
              </v-col>  
              <v-col>
                <v-autocomplete label="Order By" v-model="selected_order_by" :items="order_by_list" item-title="value" item-value="key" variant="outlined" hide-details/>
              </v-col> 
            </v-row>
            <div class="selected_rule_box mx-4" v-if="period_options.length">
              <v-checkbox v-for="item in period_options" :key="item" :label="item" :value="item"  v-model="selected_period_option" class="mr-6 radio_gp_css"  @update:modelValue="updateAllWeeksMonths(item)"/>
            </div>
            <v-row class="mx-2" v-if="repeat_freq && select_period == 'Daily'">
              <v-col cols="12">
                <div style="width: 50%;">
                  <inlineTimePicker label="Select Time" :timeValue="freq_time" :disabled="selected_freq_times.length >= repeat_freq"  :getSelectedTime="saveFreqTime" :minuteStep="5"/>
                </div>
                <span @click="addMoreTime" style="cursor: pointer; color:#0275d8;" :class="repeat_freq <= selected_freq_times.length ? 'disabled-span' :''">+Add More</span>
                <span class="ml-5">Available: {{ selected_freq_times.length }}/{{ repeat_freq }}</span>
                <div class="selected_rule_box mx-2">
                  <span v-for="(item, index) in selected_freq_times" :key="index" class="time_close_css">
                    {{ ChangeTimeFormat(item) }}
                    <v-icon style="cursor: pointer;font-size: 18px; margin-bottom: 4px;" @click="deleteTime(index)">mdi-close</v-icon>
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn small variant="outlined" color="primary" class="mb-3 text-none" @click="cancelScheduleFreq">Clear & Close</v-btn>
              <v-btn small variant="flat" color="primary" class="mb-3 text-none" @click="submitScheduleFreq">Submit</v-btn>   
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </v-row >

    <v-row class="mx-1"  v-if="bcl_action != 'Create Report' && bcl_action != 'Create Report First Page' && bcl_action != 'Create Report Second Page'">
      <v-col>
          <p class="sub_heading text-left mb-2">Schema</p>
          <v-autocomplete v-model="selected_schema" :items="schema_items" class="text-left" placeholder="Select Schema" variant="outlined" @update:modelValue="getItemDetailOptions"/>
      </v-col>
      <v-col>
          <p v-if="selected_schema" class="sub_heading text-left mb-2">Template Name</p>
          <v-text-field v-if="selected_schema" v-model="selected_template" placeholder="Select Template" variant="outlined" />
      </v-col>
    </v-row>
    
    <div v-if="bcl_action == 'Create Report First Page' && bcl_action != 'Create Report Second Page'">
      <v-row class="mx-2 mt-6">
        <v-col cols="6" class="pa-0">
            <v-text-field label="Enter Report Name" variant="outlined" v-model = "new_report_name"/>
        </v-col>
      </v-row>
      <v-row class="mx-2 mb-4" style="background-color: #ffffff; border: 1px solid #D8D9E4; border-radius: 8px ;">
          <v-col cols="6" class="text-left">
          <span style="color:#6E7089;">Schema</span>
          <span  style="font-weight: 600; margin-left: 8px;">{{ selected_schema }}</span> 
        </v-col>
          <v-col cols="6" class="text-left">
          <span style="color:#6E7089;">Template Name</span>
          <span style="font-weight: 600; margin-left: 8px;">{{ selected_template }}</span> 
        </v-col> 
      </v-row>
    </div>

    <v-row class="selected_detail_popup mx-2 mt-0" style="overflow: hidden;" v-if="selected_schema && bcl_action != 'Create Report' && bcl_action != 'Create Report Second Page'" >
      <v-col style="border-right: 1px solid #E2E3ED; margin-bottom: -44px;">
        <p class="sub_heading text-left" style="line-height: 22.4px !important;">Item Info Detail's</p>
        <v-text-field variant="outlined" v-model="search_details" prepend-inner-icon="mdi-magnify" label="Search" hide-details class="mb-3" style="max-width: 70%;"/>
        <div class="overflow-y-auto text-left overflow-x-hidden" :style="{height : content_height1}">
          <div v-for="(item,index) in item_info_details" :key="index" class="mt-3 ml-4">
            <span :class="selected_details.some(data => data.key == item.key) ? 'selected_deatils_option details_option' : 'details_option'"
              @click="update_selected_details(item)"
            >{{ item.value }} 
              <v-icon v-if = "selected_details.some(data => data.key == item.key)" class="ml-3" color="error">mdi-minus-circle-outline</v-icon>
            </span>           
          </div>
        </div>
        <div class="chevron_icon" @click="moveItemToSelectedColumn"><v-icon style="border: 1px solid;border-radius: 14px;">mdi-chevron-double-right</v-icon></div>
      </v-col>
      <v-col>
        <p class="sub_heading text-left" style="line-height: 22.4px !important;">Selected {{ bcl_action == "Create Template" ? "Template" : "Report" }} Detail's {{ confirm_selected_details.length ? `(${confirm_selected_details.length})` : ''  }}</p>
        <div class="overflow-y-auto text-left overflow-x-hidden" :style="{height : content_height2}">
          <div v-for="(item,index) in confirm_selected_details" :key="index" class="mt-3 ml-4">
            <span class="selected_deatils_option details_option">{{ item.value }} 
              <v-icon v-if="confirm_selected_details.includes(item)" class="ml-3" color="error" @click="removeSelectedDetails(item,index)">mdi-minus-circle-outline</v-icon>
            </span>           
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- seacrh, action button and filter -->
    <v-card-title
        class="action-style pb-0 mt-6" v-if="bcl_action == 'Create Report'">
        <v-row class="my-5 mx-2 mb-3">
        <v-autocomplete
          v-model="select_field"
          :items="select_field_items"
          label="Select Field"
          variant="outlined"
          style="max-width: 150px;"
          class="mr-4 text-left"
        >
        </v-autocomplete>
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          v-model="search_tag"
          label="Search"
          style="max-width: 270px;"
            variant="outlined"
          v-on:keyup.enter="getTemplates('search')"
          :disabled="!select_field"
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-row>
    </v-card-title>
    <v-layout class="ma-0 pa-0 overflow-y-auto overflow-x-hidden" v-if="bcl_action == 'Create Report'" wrap :style="{height: reportCardHeight}">
      <v-flex class="ma-0 pa-0" xs12 style="width:100%;">
        <v-row align="center" class="ma-1 pb-8">
          <v-col v-for="(item) in items" :key="item.id" block :cols="getCols()" xs12>
              <v-card class="rounded-card" :elevation="4"  @click="createReportUsingTemp(item.id)">
              <v-row class="ma-0 pa-0">
                <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <v-row align="center" style="margin:20px 25px 30px">
                    <v-col class="text-left p-0 d-flex" cols="8">
                        <img src="@/assets/images/icons/line.png" max-width="18" max-height="18" alt="icon" class="ma-1 mr-2"></img>
                      <h4
                        style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000"
                      >
                        <!-- {{ item.name }} -->
                        <span v-if="item.name && item.name.length <= 20">
                        {{ item.name }}
                        </span>
                        <span v-else-if="!item.name">
                          -
                        </span>
                        <span v-else>
                          <v-tooltip top>
                            <template v-slot:activator="{ props }">
                              <span v-bind="props" style="color: #000000; font-size: 1.2rem; white-space: nowrap;">
                                {{ item.name.substring(0, 15) }}...
                              </span>
                            </template>
                            <div style="max-width: 280px !important; word-wrap: break-word !important;">{{ item.name }}</div>
                          </v-tooltip>
                        </span>
                      </h4>
                    </v-col>
                    <v-col class="text-right p-0" cols="4">
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                    <v-col class="text-center p-0">
                      <a
                        @click="createReportUsingTemp(item.id)"
                        style="color: #003C9E; text-decoration: none;"
                      >
                        Create Report
                      </a>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <div v-if="bcl_action == 'Create Report Second Page'" class="overlfow-y-auto overflow-x-hidden"  :style="{'height' : create_report_height}">
      <v-row class="mx-2 my-4" style="background-color: #ffffff; border: 1px solid #D8D9E4; border-radius: 8px ;">
          <v-col cols="4" class="text-left">
          <span style="color:#6E7089;">Report Name</span>
          <span  style="font-weight: 500; margin-left: 8px;">{{ new_report_name }}</span> 
        </v-col>
          <v-col cols="4" class="text-left">
          <span style="color:#6E7089;">Schema</span>
          <span  style="font-weight: 500; margin-left: 8px;">{{ selected_schema }}</span> 
        </v-col>
          <v-col cols="4" class="text-left">
          <span style="color:#6E7089;">Template Name</span>
          <span style="font-weight: 500; margin-left: 8px;">{{ selected_template }}</span> 
        </v-col> 
      </v-row>
        <p class="mx-2 sub_heading text-left">Selected Report Detail's</p>
      <div class="selected_rule_box mx-2">
        <span v-for="(item, index) in confirm_selected_details" :key="index" class="rule-type_option report_details_css">
          {{ item.value }}
        </span>
      </div>

      <div class="access_control_col" :style="{'min-height' : access_control_height}">
        <v-row class="mx-2 mt-4">
          <v-col>
              <p class="sub_heading text-left">Access Control</p>
              <v-autocomplete label="Select Role" v-model="selected_role" class="text-left" :items="all_user_list" item-title="name" item-value="name" multiple variant="outlined" :disabled="email_id_list.length"/>
          </v-col>
          <v-col> 
              <p class="sub_heading text-left">Recipient's Email ID</p>
              <v-text-field placeholder="Enter Recipient's email id" v-model="entered_emailid" variant="outlined" v-on:keyup.enter="addEmailid" :disabled="selected_role.length"/>
            <div class="selected_rule_box mx-2">
              <span v-for="(item, index) in email_id_list" :key="index" class="time_close_css">
                {{ item }}
                <v-icon style="cursor: pointer;font-size: 18px; margin-bottom: 4px;" @click="deleteEmail(index)">mdi-close</v-icon>
              </span>
            </div>
          </v-col>
        </v-row>

        <v-btn variant="outlined" color="primary" class="mx-5 text-none schedule_freq_css" @click="scheduleFreqClicked">Schedule Frequency</v-btn>

        <p class="mx-6 mt-6 sub_heading text-left">Notification</p>
        <v-radio-group v-model="notification_type" row class="mx-8">
          <v-radio label="Email" value="email" class="pt-1 radio_gp_css"></v-radio>
        </v-radio-group>
      </div>
    </div>



      <v-row class="mt-2 mr-1 py-4" v-if="item_info_details.length && bcl_action != 'Create Report'">
        <v-spacer/>
          <v-btn color="primary" size="x-large" variant="outlined" class="text-none mr-3" v-if="bcl_action !== 'Create Report First Page' && bcl_action != 'Create Report Second Page'" @click="CancelDetailsSelection">Cancel</v-btn>
          <v-btn color="primary" size="x-large" variant="flat" class="text-none mr-3" v-if="bcl_action !== 'Create Report First Page' && bcl_action != 'Create Report Second Page'" @click="submitTemplateCreation"  :disabled="CheckubmitButtonDisabled">Submit</v-btn>
          <v-btn color="primary" size="x-large" variant="flat" class="text-none mr-3" v-if="(bcl_action == 'Create Report First Page' || bcl_action == 'Create Report Second Page') && !(bcl_action == 'Create Report First Page' && $store.state.action == 'Edit Report')" @click="moveToPrevCreateReportPage">Prev</v-btn>
          <v-btn color="primary" size="x-large" variant="flat" class="text-none mr-3" v-if="bcl_action == 'Create Report First Page' || bcl_action == 'Create Report Second Page'" @click="moveToNextCreateReportPage" :disabled="checkNextDisbaled">Next</v-btn>
    </v-row>
  </v-card>
</template>
<script>
import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
import inlineTimePicker from '../../../commoncomponents/inlineTimePicker.vue';
import Loading from 'vue-loading-overlay';
export default {
  data() {
    return {
      headerText: "Report Creator",
      alert: false,
      alert_type: "success",
      alert_message: "",
      snackbar: false,
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        timeout: 7500,
        title: null,
        visible: false
      },
      template_items: [],
      schema_items : [],
      select_field_items: ["Template"],
      access_control_height : '200px',
      create_report_height : '500px',
      select_field: "Template",
      search_tag: "",
      active_tab_condi: "",
      organization_name: "",
      headerTextSub: "",
      bcl_action: "",
      selected_template : null,
      selected_schema : null,
      selected_details : [],
      confirm_selected_details : [],
      content_height1:'',
      content_height2:'',
      items : [],
      new_report_name : '',
      all_user_list : [],
      notification_type: 'email',
      selected_sort_by: null,
      selected_order_by: null,
      order_by_list :[ { value: 'Ascending', key: 'asc' }, { value: 'Descending', key: 'desc' }],
      // select_freq_date : null,
      scheduleFreqPopup : false,
      repeat_freq : '',
      period_options : [],
      selected_period_option : [],
      freq_time : "00:00",
      menu4 : false,
      menu3 : false,
      selected_freq_times : [],
      selected_role : [],
      entered_emailid : '',
      select_period : null,
      email_id_list : [],
      isLoading: false,
      fullPage: true,
      primary_code: "#0275d8",
      selected_duration : null,
      menu: false,
      options_day_months: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      selectedDays: [],
      selected_template_id : '',
      selected_duration_date_field : null,
      days_selected : null,
      date_selected : null,
      date_column_list : [],
      template_column_list : [],
      report_column_list : [],
      date_selection_popup : false,
      is_showing_date_field : false,
      search_details : '',
      selected_date_columns : [],
      reportCardHeight: '400px',
      template_details: {}
    };
  },
  components: {
    HeaderComponent, Loading, inlineTimePicker
  },
  mounted() {
    this.calculateTableHeight();
    window.addEventListener('resize', this.calculateTableHeight);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  async created() {
    this.bcl_action = this.$store.state.action;
    this.headerTextSub = this.$store.state.inventoryId;
    this.getReportSchema()
    if(this.bcl_action == 'Edit Report'){
      this.bcl_action = 'Create Report First Page'
      const data = this.$store.state.lotIds
      this.new_report_name = data.report_name
      this.selected_schema = data.schema_name
      this.createReportUsingTemp(data.template_id, true)
      this.selected_template = data.template_name
      this.allUserRole()
      const lists = this.mergeAllFields(data)
      this.selected_details = lists.map(item => item)
      this.confirm_selected_details = lists.map(item => item)
    }
    if(this.bcl_action == 'Create Report')
      this.allUserRole()
    this.getTemplates();
  },
  computed:{
    CheckubmitButtonDisabled(){
      return ((this.bcl_action == "Create Template" || this.bcl_action == "Edit Template") && ( !this.selected_schema || !this.selected_template || !this.confirm_selected_details.length))
    },
    checkNextDisbaled(){
      return (this.bcl_action == 'Create Report First Page' && (!this.new_report_name || !this.confirm_selected_details.length)) 
      || (this.bcl_action == 'Create Report Second Page' && ((!this.selected_role.length && !this.email_id_list.length) || !this.notification_type || !this.selected_duration || (!this.selected_duration_date_field && this.selected_duration != 'None') || !this.select_period ||
          (this.select_period == 'Daily' && (!this.repeat_freq || !this.selected_freq_times.length) || (this.select_period == 'Weekly' && !this.days_selected) || (this.select_period == 'Monthly' && !this.date_selected)  ||
          ((this.select_period == 'Custom By Week\'s Day' || this.select_period == 'Custom By Date Of Month') && !this.selectedDays))))
    },
    item_info_details(){
      return this.is_showing_date_field? this.date_column_list.filter(item => item.value.includes(this.search_details)) :  (this.bcl_action == 'Create Template' || this.bcl_action == 'Edit Template') ? this.template_column_list.filter(item => item.includes(this.search_details)) : this.report_column_list.filter(item => item.value.includes(this.search_details))
    },
    formatted_freq_time(){
      if(this.freq_time){
        const [hour, minute] = this.freq_time.split(':').map(Number);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12;
        return `${hour12}:${String(minute).padStart(2, '0')} ${ampm}`;
      }
      return '';
    },
    selectedDaysDisplay() {
      return this.selectedDays.join(", ");
    },
  },
  watch: {
    entered_emailid(val) {
      if (val && val.includes(' ')) {
        this.entered_emailid = val.replace(/([^\s])\s+(?=[^\s])/g, '$1,');
      }
    }
  },
  methods: {
    allowedMinutes: m=> m%15 == 0,
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    getReports() {
        this.$httpSecured
        .get("/api/v2/report_builders/get_report_names")
        .then(response => {
          if (response.data) {
            this.items = response.data.reports.map(report => ({
              id: report[0],
              name: report[1]
            }));
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
        });
    },
    getTemplates() {
      this.loading = true;
      const params = {
        search: this.search_tag,
        // page: this.page,
        // per_page: this.pageSize
      };
        this.$httpSecured
        .get("/api/v2/report_builders/get_templates",{params : params})
        .then(response => {
          if (response.data) {
            this.items = response.data.templates.map(template => ({
              id: template[0],
              name: template[1]
            }));
            if(this.bcl_action == 'Create Report First Page')
              this.selected_template_id = this.items.filter(item => item.name == this.selected_template)[0].id
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
        });
    },
    getRouterLink() {
      return { name: "reportBuilder" };
    },
    componentsName() {
      return this.$store.state.action;
    },
    getRouterLinkText() {
      return this.headerTextSub;
    },
    getReportSchema(){
        this.$httpSecured
      .get("/api/v2/report_builders/get_report_schemas")
      .then(response => {
        this.schema_items = response.data.schemas
      })
      .catch(error => {
        this.showAlert("error", error.response.data.error);
      });
    },
    getItemDetailOptions(params){
      if(!params){
        this.confirm_selected_details = []
        this.selected_details  = []
      }
      this.isLoading = true
      this.$httpSecured
      .get(`/api/v2/report_builders/get_table_columns?table_name=${this.selected_schema}`)
      .then(response => {
        this.isLoading = false
        this.template_column_list = response.data.columns
        this.date_column_list = []
        const date_columns = response.data.date_columns
        for(let key in date_columns)
          this.date_column_list.push({key: date_columns[key], value: key})
        if(params){
          if(this.report_column_list && this.report_column_list.length > 0)
            this.date_column_list = this.report_column_list.filter(item => this.date_column_list.some(data => data.key ==  item.key))
          else this.date_column_list = this.report_column_list.filter(item => this.date_column_list.some(data => data.key ==  item.key))
        }
      })
      .catch(error => {
        this.isLoading = false
        this.showAlert("error", error.response.data.error);
      });
    },
    update_selected_details(item){
      if(this.selected_details.some(data => data.key == item.key))
        this.selected_details = this.selected_details.filter(data => data.key != item.key)
      else this.selected_details.push(item)
    },
    removeSelectedDetails(item,index){
      this.confirm_selected_details.splice(index,1)
      if(this.selected_details.some(data => data.key == item.key))
        this.selected_details = this.selected_details.filter(data => data.key != item.key)
    },
    moveItemToSelectedColumn(){
      const new_item = this.selected_details.filter(item => !this.confirm_selected_details.includes(item))
      this.confirm_selected_details = this.confirm_selected_details.filter(item => this.selected_details.some(data => data.key == item.key))
      this.confirm_selected_details = [...this.confirm_selected_details, ...new_item]
    },
    calculateTableHeight() {
      const viewportHeight = window.innerHeight;
      const additionalSpace = this.bcl_action == 'Create Report First Page' || this.bcl_action == 'Create Report' ? 439 : 439;
      const additionalSpace1 = 252;
      const height1 = viewportHeight  - additionalSpace1;
      const height = viewportHeight  - additionalSpace;
      this.content_height1 = (height-40)+ 'px';
      this.content_height2 = (height+30) + 'px';
      this.access_control_height = (viewportHeight - 408) + 'px'
      this.create_report_height = (viewportHeight - 190) + 'px'
      this.reportCardHeight = height1 + 'px';
    },
    CancelDetailsSelection(){
      this.confirm_selected_details = []
      this.selected_details = []
    },
    submitTemplateCreation(){
      // if(this.confirm_selected_details.filter(item => this.date_column_list.some(data => data.key ==  item.key)).length == 0){
      //   this.date_selection_popup = true
      //   return;
      // }
      const params = {
        'template_name': this.selected_template,
        'schema_name' : this.selected_schema,
        'column_names' : this.confirm_selected_details
      };
      this.isLoading = true
      if(this.$store.state.action == 'Create Template'){
          this.$httpSecured
        .post("/api/v2/report_builders/create_report_template", params)
        .then(response => {
          this.$store.commit('setMessage', { 
            responseMessage: 'Template created successfully',
            action: ''
          });
          this.isLoading = false
          this.$router.push({ name : 'reportBuilder'});
        })
        .catch(error => {
          this.isLoading = false
          this.showAlert("error", error.response.data);
        });
      } else {
          this.$httpSecured
        .put(`/api/v2/report_builders/update_report_template?id=${this.$store.state.lotIds.id}`, params)
        .then(response => {
          this.isLoading = false
          this.$store.commit('setMessage', { 
            responseMessage: 'Template updated successfully',
            action: ''
          });
          this.$router.push({ name : 'reportBuilder'});
        })
        .catch(error => {
          this.isLoading = false
          this.showAlert("error", error.response.data);
        });
      }
    },
    createReportUsingTemp(id, is_edit){
      const api = `/api/v2/report_builders/view_template?id=${id}`
      this.$httpSecured
      .get(api)
      .then(response => {
        this.bcl_action = 'Create Report First Page'
        const data = response.data
        this.template_details = data
        this.selected_template_id = id
        this.selected_schema = data.schema_name
        this.selected_template = data.template_name
        this.report_column_list = this.mergeAllFields(data).map(item => item)
        this.getItemDetailOptions(data);
        if(!is_edit){
          this.selected_details = []
          this.confirm_selected_details = []
        }
      })
      .catch(error => {
        this.showAlert("error", error.response.data.error);
      });
    },
    mergeAllFields(data){
      const lists = []
        data.selected_columns?.forEach(item => lists.push({key: item.field_name, value: item.heading}))
        data.summary_rows?.forEach(item => lists.push({key: item.field_name, value: item.heading}))
        data.custom_fields?.forEach(item => lists.push({key: item.field_name, value: item.heading}))
        data.summary_columns?.forEach(item => lists.push({key: item.field_name, value: item.heading}))
        return lists
    },
    clearAllFields(){
      this.repeat_freq = ''
      this.select_period = null
      this.selected_freq_times = []
      this.selected_role = []
      this.entered_emailid = ''
      this.notification_type = 'email'
      this.selected_sort_by = this.selected_order_by = null
      this.email_id_list = []
      this.freq_time = "00:00"
      this.period_options = []
      this.selected_duration = null
      this.selected_duration_date_field = null
      this.days_selected = null
      this.date_selected = null
      this.selectedDays = []
    },
    moveToPrevCreateReportPage(){
      if (this.bcl_action === 'Create Report Second Page') {
        this.bcl_action = 'Create Report First Page';
      } else if (this.bcl_action === 'Create Report First Page') {
        this.bcl_action = 'Create Report';
      }    
    },
    moveToNextCreateReportPage(){
      if(this.bcl_action == 'Create Report First Page'){
        // if(this.confirm_selected_details.filter(item => this.date_column_list.some(data => data.key ==  item.key)).length == 0){
        //   this.date_selection_popup = true
        //   return;
        // }
        this.bcl_action = 'Create Report Second Page'
        this.clearAllFields()
        if(this.$store.state.action == 'Edit Report'){
          const data = this.$store.state.lotIds
          this.selected_role = data.access_roles ? data.access_roles : []
          this.entered_emailid = ''
          this.email_id_list = data.emails ? data.emails : []
          this.notification_type = data.notification_type
          this.selected_order_by = data.sort_order
          this.selected_sort_by = data.sort_by
          this.selected_duration = data.report_range ? data.report_range[0].toUpperCase()+data.report_range.slice(1) : ''
          this.select_period = data.period == 'daily' || data.period == 'weekly' || data.period == 'monthly' ? data.period[0].toUpperCase()+data.period.slice(1) : data.period == 'custom_by_week' ? "Custom By Week's Day" : data.period == 'custom_by_month' ? "Custom By Date Of Month" : null
          const parts = data.query_parameter ? data.query_parameter.split('_') : []
          const capital_letter = parts.map(item => 
            item ? item[0].toUpperCase() + item.slice(1) : ''
          );
          this.selected_duration_date_field = capital_letter.length ? capital_letter.join(' ') : null
          this.updatePeriodOptions()
          if(this.select_period == "Weekly")
            this.days_selected = data.weekdays
          else if(this.select_period == "Custom By Week's Day")
            this.selectedDays = data.weekdays.split(',')
          else if(this.select_period == "Custom By Date Of Month")
            this.selectedDays = data.month_days.split(',')
          else if(this.select_period == "Monthly")  
          this.date_selected = data.month_days ? Number(data.month_days) : null
          else{
            this.repeat_freq = data.repeat_frequency
            this.selected_freq_times = data.report_delivery_times ? data.report_delivery_times.split(',') : []
          }
        }
        this.selected_date_columns = this.confirm_selected_details.filter(item => this.date_column_list.some(data => data.key ==  item.key))
      } else {
        this.isLoading = true
        const params = {
          'report_name' : this.new_report_name,
          'template_name' : this.selected_template,
          'template_id' : this.selected_template_id,
          'schema_name' : this.selected_schema,
          'access_roles' : '',
          'recipient_emails' : '',
          'weekdays' : '',
          'month_days' : '',
          'repeat_frequency' : '',
          'report_delivery_times' : '',
          'column_names' : [],
          'notification_type' : this.notification_type,
          'sort_order' : this.selected_order_by,
          'sort_by' : this.selected_sort_by,
          'query_parameter' : this.selected_duration_date_field ? this.selected_duration_date_field.toLowerCase().split(' ').join('_') : '',
          'report_range' : this.selected_duration.toLowerCase(),
          'period' : (this.select_period == 'Daily' || this.select_period == 'Weekly' || this.select_period == 'Monthly') ? this.select_period.toLowerCase() :
                  this.select_period == 'Custom By Week\'s Day' ? 'custom_by_week' : 'custom_by_month'
        }
        params.selected_columns = []
          this.confirm_selected_details.forEach(selected => {
            const match = this.template_details.selected_columns?.find(
              item => item.field_name === selected.key
            );

            if (match) {
              params.selected_columns.push(match);
            }
          });
          
        params.summary_rows = []
        this.template_details.summary_rows?.forEach(item => {
          if(this.confirm_selected_details.some(data => data.key == item.field_name))
          params.summary_rows.push(item)
        })

        params.custom_fields = []
        this.template_details.custom_fields?.forEach(item => {
          if(this.confirm_selected_details.some(data => data.key == item.field_name))
          params.custom_fields.push(item)
        })

        params.summary_columns = []
        this.template_details.summary_columns?.forEach(item => {
          if(this.confirm_selected_details.some(data => data.key == item.field_name))
          params.summary_columns.push(item)
        })

        if(this.selected_role.length)
          params['access_roles'] = this.selected_role
        else params['recipient_emails'] = this.email_id_list
        if(this.select_period == 'Weekly')
          params.weekdays = this.days_selected
        else if(this.select_period == 'Custom By Week\'s Day')
          params.weekdays = this.selectedDays.join(',')
        else if(this.select_period == 'Custom By Date Of Month')
          params.month_days = this.selectedDays.join(',')
        else if(this.select_period == 'Monthly')
          params.month_days = String(this.date_selected)
        else {
          params.repeat_frequency = this.repeat_freq
          params.report_delivery_times = this.selected_freq_times.join(',')
        }
        if(this.$store.state.action == 'Edit Report'){
            this.$httpSecured
          .put(`/api/v2/report_builders/update_report_configurations?id=${this.$store.state.lotIds.id}`, params)
          .then(response => {
            this.isLoading = false
            // this.$toast.success(response.data.message)
            this.$store.commit('setMessage', { 
              responseMessage: 'Report updated successfully',
              action: ''
            });
            this.$router.push({ name : 'reportBuilder'});
          })
          .catch(error => {
            this.isLoading = false
            this.showAlert("error", error.response.data.error);
          });
        } else{
            this.$httpSecured
          .post("/api/v2/report_builders/create_report_configurations", params)
          .then(response => {
            // this.$toast.success(response.data.message)
            this.$store.commit('setMessage', { 
              responseMessage: 'Report created successfully',
              action: ''
            });
            this.isLoading = false
            this.$router.push({ name : 'reportBuilder'});
          })
          .catch(error => {
            this.isLoading = false
            this.showAlert("error", error.response.data);
          });
        }
      }
    },
    allUserRole(){
        this.$httpSecured
      .get("/api/v2/users/all_roles")
      .then(response => {
        this.all_user_list = response.data.roles
      })
      .catch(error => {
        this.showAlert("error", error.response.data.error);
      });
    },
    scheduleFreqClicked(){
      this.scheduleFreqPopup = true
    },
    updatePeriodOptions(){
      this.selectedDays = []
      this.repeat_freq = null
      if(this.select_period === 'Custom By Week\'s Day')
        this.options_day_months = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
      else if(this.select_period === 'Custom By Date Of Month') this.options_day_months = Array.from({length: 31}, (_, i) => i + 1)
    },
    updateToDateField(){
      this.date_selection_popup = false
      this.is_showing_date_field = true
    },
    saveFreqTime(selectedTime){
      if(selectedTime){
        this.menu4 = false
        this.freq_time = selectedTime
        if (!this.selected_freq_times.includes(selectedTime)) {
          this.selected_freq_times.push(selectedTime);
        }
      }
    },
    ChangeTimeFormat(item){
      const [hour, minute] = item.split(':').map(Number);
      const ampm = hour >= 12 ? 'PM' : 'AM';
      const hour12 = hour % 12 || 12;
      return `${hour12}:${String(minute).padStart(2, '0')} ${ampm}`;
    },
    deleteTime(index){
      this.selected_freq_times.splice(index,1)
    },
    submitScheduleFreq(){
      this.scheduleFreqPopup = false
    },
    addEmailid(){
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.entered_emailid) return;
      
      const emails = this.entered_emailid.split(/[\s,]+/).filter(email => email.trim() !== '');
      let invalidEmails = [];

      emails.forEach(email => {
        if(regex.test(email)){
          if(!this.email_id_list.includes(email)){
            this.email_id_list.push(email)
          }
        } else {
          invalidEmails.push(email)
        }
      })

      if(invalidEmails.length > 0){
        this.$toast.error(`Invalid email(s): ${invalidEmails.join(', ')}`)
      }
      this.entered_emailid = ''
    },
    deleteEmail(index){
      this.email_id_list.splice(index,1)
    },
    getCols() {
      const width = window.innerWidth;
      if (width > 1600) {
        return 3;
      } else if (width > 1400) {
        return 4; 
      }
      return 4;
    },
    cancelScheduleFreq(){
      this.selected_duration = null
      this.repeat_freq = ''
      this.select_period = null
      // this.select_freq_date = null
      this.selected_freq_times = []
      this.freq_time = "00:00"
      this.selected_period_option = []
      this.scheduleFreqPopup = false
    },
    updateAllWeeksMonths(item){
      if(item == 'All Days'){
        if(this.selected_period_option.includes(item)){
          this.selected_period_option = this.period_options
        } else this.selected_period_option = []
      } else if(item == 'All Months'){
        if(this.selected_period_option.includes(item)){
          this.selected_period_option = this.period_options
        } else this.selected_period_option = []
      } else if(this.select_period == 'Weeks'){
        const index = this.selected_period_option.indexOf('All Days')
        if(this.selected_period_option.length == 7 && index == -1)
          this.selected_period_option.push('All Days')
        else 
          if(index != -1)
            this.selected_period_option.splice(index,1)
      }else if(this.select_period == 'Months'){
        const index = this.selected_period_option.indexOf('All Months')
        if(this.selected_period_option.length == 12 && index == -1)
          this.selected_period_option.push('All Months')
        else 
          if(index != -1)
            this.selected_period_option.splice(index,1)
      }
    },
    addMoreTime(){
      this.freq_time = "00:00"
      this.menu4 = true
    },
    saveSelection() {
      this.menu = false;
    },
    updateDurationDateField(){
      if(this.selected_duration == 'None') 
        this.selected_duration_date_field = null
    }
}
};
</script>
<style scoped>
.rounded-card {
  border-radius: 12px;
  overflow: hidden;
}
.selected_detail_popup{
  border-radius: 8px;
  border: 1px solid #E2E3ED;
}
.selected_deatils_option{
  background: #EDEDF8;
  border-radius: 12px;
  padding: 8px;
}
.details_option{
  color: #6E7089;
  font-size: 14px;
  font-weight: 600;
  line-height: 19.6px;
  cursor: pointer;
}
.chevron_icon{
  position: relative;
  left: 99%;
  top: -50%;
  width: 44px;
  height: 44px;
  border-radius: 22px;
  background: #EDEDF8;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}
.selected_rule_box {
  display: flex;
  flex-wrap: wrap;
}

.rule-type_option {
  padding: 12px 36px;
  border-radius: 5px;
  margin: 16px 10px 0px 10px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  border: none !important;
}
:deep(.radio_gp_css .v-label){
  margin-bottom: 0px !important;
}
.time_close_css {
  padding: 4px 8px;
  border-radius: 5px;
  margin: 4px 4px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
}
.sub_heading{
  font-size: 14px;
  font-weight: 600;
  line-height: 16.94px;
  color: #1A1B35;
}
.report_details_css{
  color: #003C9E;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.94px;
}
.access_control_col{
  background-color: #F6F5FF;
  border-radius: 8px;
}
.schedule_freq_css{
  color:#003C9E;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 19.36px !important;
  border-radius: 12px !important;
  display: flex !important;  
}
.disabled-span {
  pointer-events: none; 
  opacity: 0.5;
}
</style>
